import { nanoid } from 'nanoid';

function detectWebGL() {
	if (window.WebGLRenderingContext) {
		let canvas = document.createElement('canvas');
		let gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
		if (gl && gl instanceof WebGLRenderingContext) {
			return true;
		}
	}
	return false;
}
export default class Service {
	worker;
	listeners = {}
	constructor() {
		if (window.Worker) {
			this.worker = new Worker(new URL('./EngineWorker.js', import.meta.url), {
				type: 'module'
			});
			let _this = this
			this._statusCallback = function(e) {
				if (e.data.status) {
					for(let key in _this.listeners) {
						_this.listeners[key]?.forEach((cb) => cb(e.data[key]));
					}
				}
			}
			this.worker.addEventListener('message', this._statusCallback);
			this.worker.addEventListener('error', (e) => {
				let event = new Event('error')
				event.data = {
					type: 'error',
					error: e
				}
				window.dispatchEvent(event)
			});
		} else {
			console.error("Your browser doesn't support web workers.");
		}
	}
	on(event, callback) {
		if(!this.listeners[event]) {
			this.listeners[event] = []
		}
		this.listeners[event].push(callback);

	}
	off(event, cb)  {
		if(this.listeners[event]) {
			this.listeners[event] = this.listeners[event].filter((c) => c != cb);
		}
	}
	async cancel() {
		let id = nanoid(50);
		let message = {
			action: 'cancel',
			id: id
		};
		let m = JSON.stringify(message);
		this.worker.postMessage(m);
		return new Promise((resolve, reject) => {
			let func = (e) => {
				if (e.data.id === id) {
					this.worker.removeEventListener('message', func);
					resolve();
				}
			};
			this.worker.addEventListener('message', func);
		});

	}
	async updateProperties(properties) {
		let id = nanoid(50);
		let message = {
			action: 'updateProperties',
			id: id,
			payload: properties
		};
		let m = JSON.stringify(message);
		this.worker.postMessage(m);
		return new Promise((resolve, reject) => {
			let func = (e) => {
				if (e.data.id === id) {
					this.worker.removeEventListener('message', func);
					if (e.data.cancelled) {
						reject('cancelled');
					} else {
						resolve(e.data.payload);
					}
				}
			};
			this.worker.addEventListener('message', func);
		});
	}
	async update(tasks) {
		let id = nanoid(50);
		let message = {
			action: 'update',
			id: id,
			payload: tasks
		};
		let m = JSON.stringify(message);
		this.worker.postMessage(m);
		return new Promise((resolve, reject) => {
			let func = (e) => {
				if (e.data.id === id) {
					this.worker.removeEventListener('message', func);
					if (e.data.cancelled) {
						reject('cancelled');
					} else {
						resolve(e.data.payload);
					}
				}
			};
			this.worker.addEventListener('message', func);
		});
	}
	async render(data, properties, reset) {
			if(!detectWebGL()) {
			let event = new Event('error')
			event.data = {
				type: 'error',
				message: 'WebGL not supported.',
				error: 'WebGL not supported.'
			}
			window.dispatchEvent(event)
			return
		}
		let id = nanoid(50);
		let message = {
			action: 'render',
			id: id,
			payload: data,
			properties: properties
		};
		let m = JSON.stringify(message);
		this.worker.postMessage(m);
		return new Promise((resolve, reject) => {
			let func = (e) => {
				if (e.data.id === id) {
					this.worker.removeEventListener('message', func);
					if (e.data.cancelled) {
						reject('cancelled');
					} else {
						resolve(e.data.payload);
					}
				}
			};
			this.worker.addEventListener('message', func);
		});
	}
}
